<template>
  <div class="about">
    <h1>A site for events to match the world.</h1>
  </div>
</template>
